import * as React from 'react';
import { Navigation } from 'utils/Navigation';
import { SceneFactory } from 'scenes/SceneFactory';
import { Rpc } from 'rpc/rpc';
import { LinearProgress, createMuiTheme, MuiThemeProvider } from '@material-ui/core';

/**
 * Minimal application shell used for the unauthenticated auth pages
 * (login / register / accept invitation). Unlike MainStage it renders no side
 * menu and does not require the authenticated Meta to be loaded.
 */
export class AuthStage extends React.Component<{}, State> {

    public constructor(props: {}) {
        super(props);

        this.handleFetchingStateChanged = this.handleFetchingStateChanged.bind(this);

        this.state = { isFetching: Rpc.isFetching };
    }

    public componentDidMount() {
        Rpc.onFetchingStateChanged.addListener(this.handleFetchingStateChanged);
    }

    public componentWillUnmount() {
        Rpc.onFetchingStateChanged.removeListener(this.handleFetchingStateChanged);
    }

    private handleFetchingStateChanged(isFetching: boolean) {
        this.setState({ isFetching: Rpc.isFetching });
    }

    public render() {
        var sceneFactory = SceneFactory.getFactory(Navigation.currentState.path);
        var scene = null;
        if (sceneFactory != null) {
            scene = sceneFactory.create(Navigation.currentState);
        }
        return (
            <MuiThemeProvider theme={theme}>
                {scene == null && (<div>No scene is registered for this path</div>)}
                {scene != null && scene}

                {this.state.isFetching && (
                    <div style={{ position: 'fixed', left: '0px', top: '0px', right: '0px', bottom: '0px', zIndex: 99999, pointerEvents: 'none' }}>
                        <LinearProgress style={{ width: '100%' }} />
                    </div>
                )}
            </MuiThemeProvider>
        );
    }

}

interface State {

    isFetching: boolean;

}

const theme = createMuiTheme({
    typography: {
        useNextVariants: true,
    },
    zIndex: {
        modal: 20000,
    }
});
